import HorizontalScroller from '@/components/HorizontalScroller'
import SuggestedButtonGhost from './SuggestedButtonGhost'

const GHOST_BUTTON_COUNT = 5

type EditWithAIGhostSuggestionsProps = {
  isVisible: boolean
  width: number
  arrowsPlacement?: 'inside' | 'outside'
}

function EditWithAIGhostSuggestions({ isVisible, width }: EditWithAIGhostSuggestionsProps) {
  if (!isVisible) return null

  return (
    <HorizontalScroller width={width} showScrollArrows={false}>
      {Array.from({ length: GHOST_BUTTON_COUNT }).map((_, i) => (
        <SuggestedButtonGhost key={i} />
      ))}
    </HorizontalScroller>
  )
}

export default EditWithAIGhostSuggestions
